document.addEventListener("DOMContentLoaded", () => {
    const inner = setInterval(() => {
        const btn = document.getElementById('chat-button');
        btn?.removeAttribute('role');
        const nava = document.querySelector(".skip-to-content-link.button.visually-hidden");
        if (nava.parentNode.tagName.toLowerCase() !== 'nav') {
            const newnav = document.createElement("nav");
            newnav.setAttribute("aria-label", "Skip link navigation");
            nava.parentNode.insertBefore(newnav, nava);
            newnav.appendChild(nava);
        }
        const srLink = document.querySelector('a[data-acsb="sr-trigger"]');
        if (srLink && srLink.parentNode.tagName.toLowerCase() !== 'nav') {
            const refnav = document.createElement("nav");
            refnav.setAttribute("aria-label", "link navigation");
            srLink.parentNode.insertBefore(refnav, srLink);
            refnav.appendChild(srLink);
        }
        const nav = document.querySelector('nav[aria-label="main-nav"]');
        nav?.removeAttribute('aria-hidden');
        const btns = document.querySelectorAll('button[data-acsb-navigable="true"]');
        btns.forEach(element => {
            element.removeAttribute("aria-labelledby");
            element.removeAttribute("aria-describedby");
        });
        const temp = document.getElementById('Search-In-Template');
        temp?.removeAttribute("aria-labelledby");        
        const tempIdmobile = document.getElementById('Search-In-Modal__Mobile');
        tempIdmobile?.removeAttribute('aria-labelledby');        
        const tempId = document.getElementById('Search-In-Modal');
        tempId?.removeAttribute('aria-labelledby');
        const btnArrows = document.querySelectorAll(".fs-recommendation-right-arrow.fs-rec-widget-98h8j5");
        if (btnArrows) {
            btnArrows.forEach(element => {
                element.removeAttribute('tabindex');
                element.removeAttribute('role');
                element.removeAttribute('aria-label');
            })
        }
        const btnleftArrows = document.querySelectorAll(".fs-recommendation-left-arrow.fs-rec-widget-98h8j5");
        if(btnleftArrows) {
            btnleftArrows.forEach(element => {
                element.removeAttribute('tabindex');
                element.removeAttribute('role');
                element.removeAttribute('aria-label');
            })
        }

        const storelocator = document.querySelectorAll(".stockist-search-field");
        if(storelocator) {
            storelocator.forEach(element => {
                element.removeAttribute('aria-expanded'); 
            })
        }

        const storemap = document.querySelectorAll(".stockist-map-google");
        if(storemap) {
            storemap.forEach(element => {
                element.setAttribute('aria-label', 'Store locator map');
                element.setAttribute('title', 'Store locator map');
            })
        }
        
    }, 500)
    const fixIframe = setInterval(() => {
        const div = document.querySelector("div#PBarNextFrameWrapper");
        const iframe = div?.querySelector("iframe#PBarNextFrame");
        iframe?.setAttribute("aria-label", "iframe");
    }, 500);
    const fixheading = setInterval(() => {
        const div = document.querySelector("article div.article-template__content");
        const h4 = div?.querySelector("h4");
        h4?.setAttribute("role", "heading");
        h4?.setAttribute("aria-level", "2");
    })
    const removePopup = setInterval(() => {
        document.querySelectorAll('.zooomygallerymodal').forEach(el => {
            el.style.display = 'none';
        });
    }, 100)
    setTimeout(() => {
        clearInterval(inner);
        clearInterval(fixIframe);
        clearInterval(fixheading);
        clearInterval(removePopup);
    }, 10000)
})

function swapDivs() {
    if (window.innerWidth < 750) {
        const cartItems = document.querySelectorAll('.cart-item');
        if (cartItems.length == 0) return;
        else {
            cartItems.forEach(cartItem => {
                const price = cartItem.querySelector('.final-sale-price');
                const quantity = cartItem.querySelector('.cart-item__quantity.cart-item-quentity-f');
                const parentA = cartItem.querySelector('.cart-final-total-wrapper');
                const parentB = cartItem.querySelector('.cart-titel-item-quentity-content');
                if (parentA.contains(price) && parentB.contains(quantity)) {
                parentB.appendChild(price);
                parentA.appendChild(quantity);
                }
            })
        }
    }
}

document.addEventListener('click', (e) => {
    const cartBtn = e.target.closest("a.header__icon--cart");
    const buyBtn = e.target.closest(".product-form__buttons");
    const quantity = e.target.closest(".quantity__button");
    if(cartBtn || buyBtn || quantity) {
        const swap = setInterval(() => {
            swapDivs();
        }, 100)
        setTimeout(() => {
            clearInterval(swap);
        }, 2000)
    }
})

document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll('.redeemly-accordion');

    accordions.forEach(accordion => {
        const header = accordion.querySelector('.redeemly-accordion-header');
        const content = accordion.querySelector('.redeemly-accordion-content');
        const icon = accordion.querySelector('.redeemly-accordion-icon');

        header.addEventListener('click', () => {
            const isOpen = accordion.classList.contains('open');

            accordions.forEach(a => {
                a.classList.remove('open');
                a.querySelector('.redeemly-accordion-content').style.height = 0;
            });

            if (!isOpen) {
                accordion.classList.add('open');
                if (window.innerWidth < 750) {
                    content.style.height = "500px";
                }
                else {
                    content.style.height = '320px';
                }
            }
        });
    });

    const modalOverlay = document.querySelector('.redeemly-modal');

    document.addEventListener('click', function (e) {
        const openModalBtn = e.target.closest('.open-redeemly-modal');
        if(openModalBtn) {
            modalOverlay.classList.add('open');
        }
        
        const closeModalBtn = e.target.closest(".redeemly-close");
        if(closeModalBtn) {
            modalOverlay.classList.remove('open');
        }
    });

    modalOverlay.addEventListener('click', function (e) {
        if (e.target === modalOverlay) {
            modalOverlay.classList.remove('open');
        }
    });
});

const start = Date.now();
while (Date.now() - start < 2000) {}